import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { esProduccion } from './admin/entorno';

/*
 * Fuera de emidia.cl esto es un sitio de prueba: se marca noindex para que no
 * compita con el real por contenido duplicado, y porque ahi hay fotos que
 * todavia no estan aprobadas.
 */
if (!esProduccion()) {
  const robots =
    document.querySelector('meta[name="robots"]') ?? document.createElement('meta');
  robots.name = 'robots';
  robots.content = 'noindex, nofollow';
  if (!robots.parentNode) document.head.appendChild(robots);
}

/*
 * Las dos rutas que no son el sitio. Amplify las reescribe hacia index.html
 * —ninguna de las dos tiene punto, y su regla manda ahi todo lo que no
 * termine en una extension de su lista—, asi que las dos llegan a este
 * archivo y se resuelven aca en vez de en la consola de AWS.
 *
 *   /admin     el panel de fotos
 *   /prensado  la hoja del servicio de prensado
 *   /novias    la hoja de ramos de novia
 *
 * Las dos hojas se mandan por link y se imprimen en PDF desde el navegador.
 *
 * Las dos van en su propio trozo: quien entra a la portada no se descarga
 * ninguna de las dos.
 */
const esPanel = /^\/admin\/?$/.test(window.location.pathname);
/*
 * Cada hoja responde en singular y en plural.
 *
 * Los links se mandan escritos a mano por WhatsApp, y equivocarse entre
 * /prensado y /prensados es lo mas facil del mundo —ya paso—. Como cualquier
 * ruta que no exista cae en la portada sin decir nada, una letra de mas
 * termina en una novia mirando la home sin entender por que. Sale mas barato
 * aceptar las dos formas que explicar cual era.
 */
const HOJAS = {
  prensado: () => import('./paginas/Prensado'),
  prensados: () => import('./paginas/Prensado'),
  novias: () => import('./paginas/Novias'),
  novia: () => import('./paginas/Novias'),
};

/* Sin barras ni mayusculas: /Novias/ y /novias son la misma hoja. */
const rutaHoja = window.location.pathname.replace(/^\/+|\/+$/g, '').toLowerCase();
const cargaHoja = HOJAS[rutaHoja];

if (esPanel) {
  import('./admin/arranca').then(({ default: arrancaPanel }) => arrancaPanel());
} else {
  const root = ReactDOM.createRoot(document.getElementById('root'));

  if (cargaHoja) {
    cargaHoja().then(({ default: Hoja }) =>
      root.render(
        <React.StrictMode>
          <Hoja />
        </React.StrictMode>
      )
    );
  } else {
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  }

  reportWebVitals();
}
